<div class="page-content">

  <header class="pageHeader">
    <h3><i class="fa fa-exchange fa-lg page-caption" aria-hidden="true"></i> Change Requests</h3>
  </header>

  <div class="card">
    <div class="card-body">

      <!-- KPI Cards Row -->
      <div class="row mb-4">

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('New')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === 'New' ? 'border-left-primary active-filter' : 'border-left-primary'">
            <div class="card-body py-3">
              <div class="kpi-label text-primary text-uppercase font-weight-bold small">New</div>
              <div class="kpi-value display-5 font-weight-bold">{{ NewCount }}</div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('Working')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === 'Working' ? 'border-left-danger active-filter' : 'border-left-danger'">
            <div class="card-body py-3">
              <div class="kpi-label text-danger text-uppercase font-weight-bold small">Working</div>
              <div class="kpi-value display-5 font-weight-bold text-danger">{{ WorkingCount }}</div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('Closed')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === 'Closed' ? 'border-left-success active-filter' : 'border-left-success'">
            <div class="card-body py-3">
              <div class="kpi-label text-success text-uppercase font-weight-bold small">Completed</div>
              <div class="kpi-value display-5 font-weight-bold text-success">{{ CompletedCount }}</div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('Hold')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === 'Hold' ? 'border-left-warning active-filter' : 'border-left-warning'">
            <div class="card-body py-3">
              <div class="kpi-label text-warning text-uppercase font-weight-bold small">On Hold</div>
              <div class="kpi-value display-5 font-weight-bold text-warning">{{ OnHoldCount }}</div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('Ready to Close')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === 'Ready to Close' ? 'border-left-info active-filter' : 'border-left-info'">
            <div class="card-body py-3">
              <div class="kpi-label text-info text-uppercase font-weight-bold small">Ready to Close</div>
              <div class="kpi-value display-5 font-weight-bold text-info">{{ ReadytoCloseCount }}</div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md-2 mb-3 pointer" (click)="filterTableByStatus('')">
          <div class="card kpi-card h-100" [ngClass]="selectedFilter === '' ? 'border-left-secondary active-filter' : 'border-left-secondary'">
            <div class="card-body py-3">
              <div class="kpi-label text-secondary text-uppercase font-weight-bold small">Total</div>
              <div class="kpi-value display-5 font-weight-bold text-secondary">{{ TotalCount }}</div>
            </div>
          </div>
        </div>

      </div>

      <hr class="hr-separator mb-3">

      <div class="row align-items-end mb-3">

        <div class="col-md-3 mb-2">
          <div class="form-check mt-4">
            <input class="form-check-input" type="checkbox" id="showInsuranceUpdates"
                   [checked]="showInsuranceUpdates" (change)="onToggleInsuranceUpdates($event)" />
            <label class="form-check-label" for="showInsuranceUpdates">Show Insurance Updates</label>
          </div>
        </div>

        <div class="col-md-3 mb-2">
          <label class="form-label">ICD Company Name</label>
          <ng-select [searchable]="true" [clearable]="true" placeholder="All"
                     [(ngModel)]="selectedCompany" (change)="filterTableByCompany($event)">
            <ng-option *ngFor="let o of companyOptions" [value]="o">{{ o }}</ng-option>
          </ng-select>
        </div>

        <div class="col-md-3 mb-2">
          <label class="form-label">ICD Owner Name</label>
          <ng-select [searchable]="true" [clearable]="true" placeholder="All"
                     [(ngModel)]="selectedOwner" (change)="filterTableByOwner($event)">
            <ng-option *ngFor="let o of ownerOptions" [value]="o">{{ o }}</ng-option>
          </ng-select>
        </div>

        <div class="col-md-3 mb-2">
          <label class="form-label">Request</label>
          <ng-select [searchable]="true" [clearable]="true" placeholder="All"
                     [(ngModel)]="selectedRequest" (change)="filterTableByRequest($event)">
            <ng-option *ngFor="let o of requestOptions" [value]="o">{{ o }}</ng-option>
          </ng-select>
        </div>

      </div>

      <!-- Table -->
      <table id="tbldata" datatable [dtOptions]="dtOptions" class="row-border hover w-100"></table>

    </div>
  </div>

</div>
